import { lazy } from 'react';

export const Accordion = lazy(() => import('./AccordionPage'));
export const ColorPicker = lazy(() => import('./ColorPickerPage'));
export const SidebarNav = lazy(() => import('./SidebarNavPage'));
export const ConfigPane = lazy(() => import('./ConfigPanePage'));
export const PageLayout = lazy(() => import('./PageLayoutPage'));
export const Input = lazy(() => import('./InputPage'));
export const Tabs = lazy(() => import('./TabsPage'));
export const FullScreenTakeover = lazy(() =>
    import('./FullScreenTakeoverPage')
);
export const PhoneNumberInput = lazy(() => import('./PhoneNumberInputPage'));
export const NumberStepper = lazy(() => import('./NumberStepperPage'));
export const Combobox = lazy(() => import('./ComboboxPage'));
export const SplitButton = lazy(() => import('./SplitButtonPage'));
export const FilterAnchor = lazy(() => import('./FilterAnchorPage'));
